import { api as axios } from '../api';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import url from '../serverUrl';
import { Alert, Collapse, LinearProgress } from '@mui/material';
import * as actionTypes from '../store/actionTypes';
import logo from '../assets/images/logo.png';
import './dashboard.css';
import { useDispatch } from 'react-redux';
export default function Login() {
  const [inputData, setInputData] = useState({ email: '', password: '' });
  const [alert, setAlert] = useState({ type: '', show: false, msg: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hanldeSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    // eslint-disable-next-line eqeqeq
    if (inputData.email.length == 0 || inputData.password.length == 0) {
      setAlert({
        msg: 'Please fill all required fields',
        type: 'error',
        show: true
      });
      setLoading(false);
      setTimeout(() => {
        setAlert({
          msg: '',
          type: '',
          show: false
        });
      }, 2500);
      return;
    }
    axios
      .post(`${url}/user/login`, {
        email: inputData.email,
        password: inputData.password
      })
      .then((res) => {
        // eslint-disable-next-line eqeqeq
        if (res.data.loggedIn == true) {
          setAlert({
            msg: 'Login Success',
            type: 'success',
            show: true
          });
          setTimeout(() => {
            setAlert({
              msg: '',
              type: '',
              show: false
            });
          }, 3000);
          localStorage.setItem(
            'hootdex_secretcookie',
            JSON.stringify(res.data)
          );

          dispatch({ type: actionTypes.FETCH_USER_INFO, UserInfo: res.data });

          navigate('/');
        } else {
          setAlert({
            msg: res.data.message,
            type: 'error',
            show: true
          });
          setTimeout(() => {
            setAlert({
              msg: '',
              type: '',
              show: false
            });
          }, 3000);
        }
      })
      .catch((err) => {
        setAlert({
          msg: err.message,
          type: 'error',
          show: true
        });
        setTimeout(() => {
          setAlert({
            msg: '',
            type: '',
            show: false
          });
        }, 3000);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setInputData({ ...inputData, [name]: value });
  };
  return (
    <div className="x-auth">
      <form className="x-auth-card" onSubmit={hanldeSubmit} noValidate>
        <img alt="HootDex" src={logo} />
        <div>
          <h1>Sign in</h1>
          <p>Use your HootDex account to open your dashboard.</p>
        </div>
        <Collapse in={alert.show}>
          <Alert severity={alert.type || 'info'} variant="outlined">
            {alert.msg}
          </Alert>
        </Collapse>
        <label className="x-auth-field">
          Email
          <input
            type="email"
            name="email"
            autoComplete="email"
            onChange={handleChange}
            value={inputData.email}
            placeholder="you@example.com"
          />
        </label>
        <label className="x-auth-field">
          Password
          <input
            type="password"
            name="password"
            autoComplete="current-password"
            onChange={handleChange}
            value={inputData.password}
            placeholder="Password"
          />
        </label>
        {loading && <LinearProgress />}
        <button className="x-btn-primary" disabled={loading}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
        <div className="x-auth-foot">
          New to HootDex?{' '}
          <a href="https://www.pecunovus.net/signup" target="_blank" rel="noreferrer">
            Create a wallet
          </a>
        </div>
      </form>
    </div>
  );
}
